/*  ===================================
 *  FREE SHIPPING TRESHOLD WIDGET
 *  - Simple widget that adds a progress bar indicating how far they are for free shipping
 *  ===================================
 */

(function(w, d, Shopify){
    const settings = {
        container: 'FSTContainer',
        progress_bar: 'FSTBar',
        message: 'FSTMessage',
        message_error: 'Please enter a target amounts in Theme Settings > Cart Promotions'
    }

    const container = d.getElementById(settings.container);
    const jsonData = JSON.parse(container.nextElementSibling.textContent);
    const enabledTargets = jsonData.targets.filter(obj => obj.enabled);
    const allTargets = enabledTargets.map(obj => obj.value);
    const maxTarget = Math.max(...allTargets); // Finds the highest target between shipping and the tiers
    let currencySymbol = '$';

    function initData() {
      if (theme.storeCurrency) {
        for (let currency of theme.storeCurrency) {
          if (Object.keys(currency)[0] === Shopify.currency.active) {
            currencySymbol = Object.values(currency)[0]
            break;
          }
        }
      }
    }

    async function fetchCartData() {
        let r = await fetch('/cart.js', {
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        let d = await r.json();
        calculateShipping(d);
    }

    function convertToCurrency(amount) {
        return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * Number(amount)) : Math.trunc(Number(amount))
    }

    function renderElements() {
        const labelHTML = d.createElement('label')
        labelHTML.classList.add('visually-hidden');
        labelHTML.setAttribute('for', settings.progress_bar)
        labelHTML.textContent = 'Promotion progress'

        const progressBarHTML = d.createElement('progress')
        progressBarHTML.id = settings.progress_bar
        progressBarHTML.setAttribute('max', 100)
        progressBarHTML.setAttribute('value', 0)
        progressBarHTML.dataset.target = convertToCurrency(maxTarget);

        const progressBarWrapper = d.createElement('div')
        progressBarWrapper.classList.add('fst-progress-bar-wrapper')
        progressBarWrapper.dataset.target = convertToCurrency(maxTarget);
        progressBarWrapper.appendChild(progressBarHTML)
        progressBarWrapper.setAttribute('data-currency-symbol', currencySymbol);

        // Add all promos to progress bar wrapper
        for (const promo of enabledTargets) {
          const elem = document.createElement('span');
          elem.dataset.target = convertToCurrency(promo.value);
          elem.dataset.currencySymbol = currencySymbol;
          elem.style.setProperty('--position', (promo.value/maxTarget) * 100);
          elem.classList.add('promotion-button', `promotion--${promo.name}`);
          elem.setAttribute('aria-hidden', true);
          if(promo.name != 'shipping' && promo.value != 0) {
            elem.setAttribute('data-arkhi-freegift-threshold', promo.value);
          }
          progressBarWrapper.appendChild(elem);
        }       

        container.appendChild(labelHTML);
        container.appendChild(progressBarWrapper);

        const messageHTML = d.createElement('div')
        messageHTML.id = settings.message
        messageHTML.classList.add('fst-message')

        container.appendChild(messageHTML);
    }

    function calculateShipping(cartJson) {
        // Sort targets from lowest to highest and remove any empty targets
        const targets = enabledTargets.sort((a, b) => a.value - b.value).filter(target => target.value);
        const total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
        const cart_total = total > 0 ? total / 100 : 0;
        const progress_value = (cart_total / convertToCurrency(maxTarget)) * 100;
        let message = '';

        if (progress_value >= 100){
          d.getElementById(settings.progress_bar).setAttribute('value', 100);
          d.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
        }
        else {
          d.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
          d.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
        }

        if (!maxTarget) {
          message = settings.message_error
          return;
        }

        if (cart_total <= 0) {
          message = jsonData.messaging.default;
        }
        else {
          for (let target of targets) {
            const remaining = target.value - cart_total;
  
            if (remaining <= 0) {
              message += `${target.messaging.success}<br/>` ?? '';
            }
            else {
              message += target.messaging.ongoing.replace('[remaining]', `${currencySymbol}${remaining ? remaining.toFixed(2) : target.value.toFixed(2)}`) ?? '';
              break;
            }
          }
        }
        // Display message
        d.getElementById(settings.message).innerHTML = message;
    }

    function init() {
        if (!container) return;

        initData();
        renderElements();
        fetchCartData();

        // Listeners for product added and cart updates
        ['cart:updated', 'ajaxProduct:added'].forEach(evt =>
            d.addEventListener(evt, fetchCartData, false)
        );
    }

    init();
})(window, document, Shopify)